<template>
   <div>
      <h1 class="">
         <i class="icon icon-activity"></i><br />
         Sorry, we didn't find anything there.
      </h1>
   </div>
</template>
